const selectors = {
  container: '.faq__accordion',
  description: '.faq__accordion-description',
  menuItems: '.faq__menu-item',
  titleDividers: '.faq__divider',
  menuButton: '.faq__menu-button',
  menuWrapper: '.faq__menu-wrapper',
  menu: '.faq__menu',
  anchorTargets: 'a[href^="#"]',
  utilityBar: '.utility-bar',
  headerWrapper: '.header-wrapper',
  breadcrumbsWrapper: '.breadcrumbs-wrapper',
  body: 'body',
  active: 'faq__accordion--active',
  menuActive: 'faq__menu-item--active',
  menuButtonNext: 'faq__menu-button--next',
  menuButtonPrev: 'faq__menu-button--prev',
};

const utilityBar = document.querySelector(selectors.utilityBar) ? document.querySelector(selectors.utilityBar) : '';
const headerWrapper = document.querySelector(selectors.headerWrapper);
const body = document.querySelector(selectors.body);
const breadcrumbs = document.querySelector(selectors.breadcrumbsWrapper)

class FAQPage extends HTMLElement {
  constructor() {
    super();
    this.addEventListeners();
    this.setMenuTop();
  }

  setMenuTop() {
    const breadcrumbsHeight = breadcrumbs.offsetHeight;
    const headerHeight = headerWrapper.offsetHeight;
    const headerHeightFull = headerHeight + utilityBar.offsetHeight;

    if (window.innerWidth <= 768) {
      if (body.classList.contains('header-is-sticky')) {
        this.querySelector(selectors.menu).style.top = `${headerHeight}px`;
      } else {
        this.querySelector(selectors.menu).style.top = `${headerHeightFull + breadcrumbsHeight}px`;
      }
    }  else {
      this.querySelector(selectors.menu).style.top = 'unset';
    }
  }

  addEventListeners() {
    this.smoothScroll();
    this.checkMenuOverflow();
    this.showPrevButton();

    const accordions = this.querySelectorAll(selectors.container);
    const menuButtonNext = this.querySelector(`.${selectors.menuButtonNext}`);
    const menuButtonPrev = this.querySelector(`.${selectors.menuButtonPrev}`);

    accordions.forEach((accordion) => accordion.addEventListener('click', this.accordionOpen.bind(this)));
    menuButtonNext.addEventListener('click', this.handleMenuButtonClickNext.bind(this));
    menuButtonPrev.addEventListener('click', this.handleMenuButtonClickPrev.bind(this));
    window.addEventListener('scroll', this.setActiveMenuItem.bind(this));
    window.addEventListener('resize', this.checkMenuOverflow.bind(this));
  }

  smoothScroll() {
    const targets = this.querySelectorAll(selectors.anchorTargets);

    if (targets.length === 0) return;

    targets.forEach((target) => {
      target.addEventListener('click', (event) => {
        event.preventDefault();
        const href = target.getAttribute('href');
        const scrollStopTarget = this.querySelector(href === '' ? 'html' : href);
        const targetPosition = scrollStopTarget.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = targetPosition - 120;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      });
    });
  }


  checkMenuOverflow() {
    const menuWidth = this.querySelector(selectors.menu).clientWidth;
    const menuWrapper = this.querySelector(selectors.menuWrapper);
    const menuWrapperWidth = menuWrapper.offsetWidth;
    const menuButtonNext = this.querySelector(`.${selectors.menuButtonNext}`);
    const menuItems = this.querySelectorAll(selectors.menuItems);

    if (menuWrapperWidth > menuWidth && !menuItems[menuItems.length - 1].classList.contains(selectors.menuActive)) {
      menuButtonNext.removeAttribute('disabled');
    } else {
      menuButtonNext.setAttribute('disabled', true);
    }
  }

  getTranslateX(element) {
    return +element.getAttribute('data-transform');
  }

  showPrevButton() {
    const menuButtonPrev = this.querySelector(`.${selectors.menuButtonPrev}`);
    const menuWrapper = this.querySelector(selectors.menuWrapper);
    const transformNum = this.getTranslateX(menuWrapper);

    if (transformNum < 0) {
      menuButtonPrev.removeAttribute('disabled');
    } else {
      menuButtonPrev.setAttribute('disabled', true);
    }
  }

  handleMenuButtonClickNext() {
    const menuButtonPrev = this.querySelector(`.${selectors.menuButtonPrev}`);
    const menuButtonNext = this.querySelector(`.${selectors.menuButtonNext}`);
    const menuWidth = this.querySelector(selectors.menu).clientWidth;
    const menuWrapper = this.querySelector(selectors.menuWrapper);
    let menuFocusItem = menuWrapper.dataset.item;
    const menuItems = this.querySelectorAll(selectors.menuItems);
    const maxScroll = menuWrapper.offsetWidth - menuWidth;
    const itemWidth = menuFocusItem == 0 ? menuItems[menuFocusItem].offsetWidth + 10 : menuItems[menuFocusItem].offsetWidth + 10;
    const scrollDistance = itemWidth * -1;
    const transformNum = this.getTranslateX(menuWrapper);
    const scrolledDistanse = (transformNum + scrollDistance) * -1;
    const translateFinal = scrolledDistanse >= maxScroll ? maxScroll : maxScroll - scrolledDistanse;

    menuWrapper.style.transform = `translateX(${translateFinal >= maxScroll ? maxScroll * -1 : scrollDistance + transformNum}px)`;
    menuWrapper.dataset.transform = translateFinal >= maxScroll ? maxScroll * -1 : scrollDistance + transformNum;
    menuWrapper.dataset.item = +menuFocusItem + 1;
    menuButtonPrev.removeAttribute('disabled');

    if (translateFinal >= maxScroll) {
      menuButtonNext.setAttribute('disabled', true);
      menuFocusItem = 0;
      menuWrapper.dataset.item = 0;
    }
  }

  handleMenuButtonClickPrev() {
    const menuButtonNext = this.querySelector(`.${selectors.menuButtonNext}`);
    const menuButtonPrev = this.querySelector(`.${selectors.menuButtonPrev}`);
    const menuWidth = this.querySelector(selectors.menu).clientWidth;
    const menuWrapper = this.querySelector(selectors.menuWrapper);
    const menuItems = this.querySelectorAll(selectors.menuItems);
    const scrollDistance = (menuWidth / menuItems.length + 100);
    const transformNum = this.getTranslateX(menuWrapper);
    const translateFinal = (scrollDistance + transformNum);

    menuWrapper.style.transform = `translateX(${translateFinal > 0 ? 0 : scrollDistance + transformNum}px)`;
    menuWrapper.dataset.transform = translateFinal > 0 ? 0 : scrollDistance + transformNum;
    menuButtonNext.removeAttribute('disabled');

    if (translateFinal > 0) {
      menuButtonPrev.setAttribute('disabled', true);
    }
  }

  setActiveMenuItemDesktop() {
    let isScrolling = false;
    const menuItems = this.querySelectorAll(selectors.menuItems);
    const titleDividers = this.querySelectorAll(selectors.titleDividers);
    const scrollY = window.scrollY;

    if (!isScrolling) {
      titleDividers.forEach((divider, index) => {
        const sectionTop = divider.offsetTop;
        const sectionHeight = divider.clientHeight;

        if (scrollY >= sectionTop - 135 && scrollY < sectionTop + sectionHeight - 135) {
          menuItems.forEach((item) => item.classList.remove(selectors.menuActive));
          menuItems[index].classList.add(selectors.menuActive);
        }
      });

      isScrolling = true;

      requestAnimationFrame(() => {
        isScrolling = false;
      });
    }
  }

  setActiveElement(menuWrapper, menuWidth, scrollNumFinal, menuButtonNext, menuButtonPrev, maxScroll, menuItems) {
    const menuWrapperWidth = menuWrapper.offsetWidth;

    if (menuItems[0].classList.contains(selectors.menuActive)) {
      menuWrapper.style.transform = 'translateX(0px)';
      menuWrapper.dataset.transform = 0;
      menuButtonPrev.setAttribute('disabled', true);

      if (menuWrapperWidth > menuWidth && !menuItems[menuItems.length - 1].classList.contains(selectors.menuActive)) {
        menuButtonNext.removeAttribute('disabled');
      }
      return;
    } else if (menuWrapperWidth > menuWidth) {
      menuButtonPrev.removeAttribute('disabled');
    }

    if (menuItems[menuItems.length - 1].classList.contains(selectors.menuActive)) {
      menuWrapper.style.transform = `translateX(-${maxScroll}px)`;
      menuButtonNext.setAttribute('disabled', true);
      menuWrapper.dataset.transform = maxScroll * -1;
      return;
    }

    if (menuWrapper.offsetWidth - menuWidth < scrollNumFinal) {
      menuWrapper.style.transform = `translateX(-${maxScroll}px)`;
      menuButtonNext.setAttribute('disabled', true);
      menuWrapper.dataset.transform = maxScroll * -1;
    } else {
      menuWrapper.style.transform = `translateX(-${scrollNumFinal < 0 ? 0 : scrollNumFinal}px)`;
      menuWrapper.dataset.transform = scrollNumFinal < 0 ? 0 : scrollNumFinal * -1;
      menuButtonNext.removeAttribute('disabled');
    }
  }

  setActiveMenuItemMobile() {
    let isScrolling = false;
    let debounceTimeout;
    const menuItems = this.querySelectorAll(selectors.menuItems);
    const titleDividers = this.querySelectorAll(selectors.titleDividers);
    const menuButtonNext = this.querySelector(`.${selectors.menuButtonNext}`);
    const menuButtonPrev = this.querySelector(`.${selectors.menuButtonPrev}`);
    const scrollY = window.scrollY;

    if (!isScrolling) {
      const menuWidth = this.querySelector(selectors.menu).clientWidth;
      const menuWrapper = this.querySelector(selectors.menuWrapper);

      titleDividers.forEach((divider, index) => {
        const sectionTop = divider.offsetTop;
        const sectionHeight = divider.clientHeight;
        const scrollNum = menuItems[index].offsetLeft - menuItems[index].offsetWidth;
        const scrollNumFinal = scrollNum - menuWrapper.scrollLeft;
        const maxScroll = menuWrapper.offsetWidth - menuWidth;

        if (scrollY >= sectionTop - 135 && scrollY < sectionTop + sectionHeight - 135) {
          menuItems.forEach((item) => item.classList.remove(selectors.menuActive));
          menuItems[index].classList.add(selectors.menuActive);

          window.addEventListener('scroll', () => {
            if (debounceTimeout) {
              clearTimeout(debounceTimeout);
            }
            debounceTimeout = setTimeout(() => {
              this.setActiveElement(menuWrapper, menuWidth, scrollNumFinal, menuButtonNext, menuButtonPrev, maxScroll, menuItems);
            }, 500);
          });

        } else if (scrollY <= 170) {
          menuItems.forEach((item) => item.classList.remove(selectors.menuActive));
          menuItems[0].classList.add(selectors.menuActive);
          this.setActiveElement(menuWrapper, menuWidth, scrollNumFinal, menuButtonNext, menuButtonPrev, maxScroll, menuItems);
          menuButtonPrev.setAttribute('disabled', true);
        }
      });

      isScrolling = true;

      requestAnimationFrame(() => {
        isScrolling = false;
      });
    }
  }

  setActiveMenuItem() {
    if (window.innerWidth <= 768) {
      this.setActiveMenuItemMobile();
    } else {
      this.setActiveMenuItemDesktop();
    }

    this.setMenuTop();
  }

  mediaPadding() {
    return window.innerWidth >= 769 ? 32 : 22;
  }

  removeActive() {
    const activeStates = this.querySelectorAll(`.${selectors.active}`);

    if (activeStates) {
      activeStates.forEach((active) => {
        const activeItem = active;
        activeItem.classList.remove(selectors.active);
        activeItem.querySelector(selectors.description).style.height = 0;
      });
    }
  }

  accordionOpen(event) {
    const currentItem = event.currentTarget;
    const description = currentItem.querySelector(selectors.description);
    const descriptionHeight = description.scrollHeight;

    if (event.target.tagName.toLowerCase() === 'a' || window.innerWidth > 768) return;

    if (currentItem.classList.contains(selectors.active)) {
      this.removeActive();
      description.style.height = 0;
    } else {
      this.removeActive();
      currentItem.classList.add(selectors.active);
      description.style.height = `${descriptionHeight + this.mediaPadding()}px`;
    }
  }
}

window.customElements.define('faq-page', FAQPage);
